var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.user.role == "manager"
        ? _c(
            "div",
            { attrs: { id: "request" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "right",
                    title: _vm.$t("Cuona.Device.title05"),
                    width: "200",
                    trigger: "hover",
                    content: _vm.$t("Cuona.Device.description03"),
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "question",
                      attrs: { slot: "reference", type: "text" },
                      slot: "reference",
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      _vm.isShowingDialog = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Device.request_device")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { id: "devices" } },
        [
          _vm.isDirty()
            ? _c(
                "el-alert",
                {
                  staticClass: "dirty",
                  attrs: {
                    type: "warning",
                    title: _vm.$t("Cuona.Device.NfcUpdate.multiple_are_dirty"),
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "mini" },
                      on: { click: _vm.updateDevicesNFC },
                    },
                    [_vm._v(_vm._s(_vm.$t("Cuona.Device.update")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("DevicesTable", {
                staticClass: "group",
                attrs: {
                  devices: _vm.devices,
                  edit: false,
                  loading: _vm.isLoading,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("RequestProduct", { attrs: { showing: _vm.isShowingDialog } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }